import classNames from 'classnames';
import * as React from 'react';
import css from './MerchantCourseDetailsHeaderImage.module.scss';

import { MerchantBookingPrimaryImage } from '../../../../../../interfaces/merchants/bookings';

interface Props {
  name: string;
  primary_image: MerchantBookingPrimaryImage;
}

const MerchantCourseDetailsHeader: React.FC<Props> = (props: Props) => {
  const {
    name,
    primary_image: {
      meta: { width, height },
      p800x600,
      p1280x1280,
    },
  } = props;
  const classes = classNames(css.MerchantCourseDetailsHeaderImage, {
    [css.isLargePortrait]: width >= 640 && height > width,
    [css.isMiddle]: width < 640 && width >= 400,
    [css.isSmall]: width < 400 && width >= 200,
    [css.isTiny]: width < 200,
  });
  const srcUrl = width <= 800 ? p800x600!.url : p1280x1280!.url;

  return <img className={classes} src={srcUrl} alt={name} />;
};

export default MerchantCourseDetailsHeader;
